(() => {
  if (customElements.get('ww-music')) return;
  class WwMusic extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.audio = this.querySelector('audio');
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-music-label]');
      this.status = this.querySelector('[data-music-status]');
      this.credits = this.querySelector('details');
      if (!this.audio || !this.button || !this.dataset.source) return;
      this.startAt = Math.max(0, Number(this.dataset.startAt) || 0);
      this.loopTrack = this.audio.loop;
      if (this.startAt > 0) this.audio.loop = false;
      this.key = 'ww-music-v2:' + this.dataset.source.split('?')[0] + ':' + this.startAt;
      this.remember = this.dataset.remember === 'true' && this.dataset.designMode !== 'true';
      this.audio.volume = Math.max(0, Math.min(1, (Number(this.dataset.volume) || 15) / 100));
      this.desired = false;
      this.resumeTime = this.startAt;
      this.lastSave = 0;
      let previous = null;
      try { if (this.remember) previous = JSON.parse(sessionStorage.getItem(this.key)); } catch (_) {}
      if (previous && Number.isFinite(previous.time)) this.resumeTime = Math.max(this.startAt, previous.time);
      this.audio.addEventListener('loadedmetadata', () => {
        if (this.resumeTime > 0 && Number.isFinite(this.audio.duration)) {
          try { this.audio.currentTime = Math.min(this.resumeTime, Math.max(0, this.audio.duration - .25)); } catch (_) {}
        }
        this.resumeTime = this.startAt;
      }, options);
      this.button.addEventListener('click', () => {
        if (this.desired || !this.audio.paused) this.stop();
        else this.start();
      }, options);
      this.audio.addEventListener('playing', () => {
        if (!this.desired) { this.audio.pause(); return; }
        this.paint(true);
        this.save();
      }, options);
      this.audio.addEventListener('pause', () => this.paint(false), options);
      this.audio.addEventListener('ended', () => {
        this.resumeTime = this.startAt;
        if (this.loopTrack && this.desired) { this.audio.currentTime = this.startAt; this.start(); }
        else this.stop();
      }, options);
      this.audio.addEventListener('error', () => {
        this.stop();
        this.status.textContent = this.dataset.errorLabel;
      }, options);
      this.audio.addEventListener('timeupdate', () => {
        if (Date.now() - this.lastSave > 2000) { this.save(); this.lastSave = Date.now(); }
      }, options);
      window.addEventListener('pagehide', () => this.save(), options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.credits.open = false; }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.credits.open) {
          this.credits.open = false;
          this.credits.querySelector('summary').focus();
        }
      }, options);
      this.hidden = false;
      this.paint(false);
      if (previous?.on && this.remember) this.start(true);
    }
    async start(resuming = false) {
      this.desired = true;
      this.status.textContent = '';
      if (!this.audio.getAttribute('src')) this.audio.src = this.dataset.source;
      try {
        if (this.audio.readyState > 0 && (this.audio.currentTime < this.startAt || this.audio.ended)) this.audio.currentTime = Math.min(this.startAt, Math.max(0, this.audio.duration - .25));
        await this.audio.play();
        if (!this.desired) this.audio.pause();
      } catch (error) {
        if (error.name === 'AbortError' || !this.desired) return;
        this.desired = false;
        this.paint(false);
        this.status.textContent = error.name === 'NotAllowedError' || resuming ? this.dataset.resumeLabel : this.dataset.errorLabel;
      }
    }
    stop() {
      this.desired = false;
      this.audio.pause();
      this.paint(false);
      this.save();
    }
    paint(playing) {
      this.button.setAttribute('aria-pressed', String(playing));
      this.label.textContent = playing ? this.dataset.onLabel : this.dataset.offLabel;
    }
    save() {
      if (!this.remember) return;
      try { sessionStorage.setItem(this.key, JSON.stringify({on:this.desired,time:this.audio.currentTime || this.resumeTime || 0})); } catch (_) {}
    }
    disconnectedCallback() {
      this.save();
      this.controller?.abort();
      this.audio?.pause();
      this.controller = null;
    }
  }
  customElements.define('ww-music', WwMusic);
})();
